import { BaseClient } from '../client';
import { TConcessionariaRevenda } from './concessionariaRevenda.types';

interface ApiResponse<T> {
	success: boolean;
	message: string;
	data: T;
}

export const getVinculosPorRevenda = async (revendaId: number) => {
	try {
		const response = await BaseClient.get<ApiResponse<TConcessionariaRevenda[]>>(
			`v2/ConcessionariaRevenda/PorRevenda`,
			{ params: { revendaId } }
		);

		return response.data.data;
	} catch (error) {
		console.error(error);
		throw error;
	}
};
